import {
  Dialog,
  DropdownField,
  SubmissionForm,
  IDialogProps,
  IDropdownOption
} from "@bps/fluent-ui";

import { TtmFormsRefreshOptions } from "@libs/api/gateways/ttm/forms/ttm-forms-ops-gateway.dtos";

interface FormsOptionsModalProps extends Pick<IDialogProps, "onDismiss"> {
  onSubmit: (options: TtmFormsRefreshOptions) => Promise<void>;
}

export const FormsOptionsModal = ({
  onDismiss,
  onSubmit
}: FormsOptionsModalProps) => {
  const options: IDropdownOption<string>[] = [
    { key: "ALL", text: "All" },
    { key: "Clinical", text: "Clinical" },
    { key: "PracticeManagement", text: "Practice Management" },
    { key: "ACC", text: "ACC" }
  ];

  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{ showCloseButton: true, title: "Refresh" }}
    >
      <SubmissionForm<TtmFormsRefreshOptions>
        initialValues={{ DomainCode: "ALL" }}
        onSubmit={onSubmit}
        cancelButtonProps={{ onClick: () => onDismiss?.(), text: "Close" }}
        submitButtonProps={{ text: "Send", alwaysEnabled: true }}
      >
        {() => (
          <DropdownField name="DomainCode" label="Domains" options={options} />
        )}
      </SubmissionForm>
    </Dialog>
  );
};
